import baseApi from '../api/baseApi';

/************************************************** API **************************************************/
export const bookkeepersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookkeepers: builder.query({
      query: () => ({
        url: 'bookkeepers',
        method: 'GET'
      }),
      transformResponse: (response) => response.data
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useGetBookkeepersQuery } = bookkeepersApi;
